// @flow

/**
 * Each index of the object is named as
 * a type and returns a function that
 * checks if the param match that type
 * @param  {Subject} any
 * @return {bool}
 */
const is = {
  undef: (v: any): boolean => v === null || v === undefined,
  notUndef: (v: any): boolean => v !== null && v !== undefined,
  func: (f: any): boolean => typeof f === 'function',
  number: (n: any): boolean => typeof n === 'number',
  string: (s: any): boolean => typeof s === 'string',
  bool: (s: any): boolean => s === true || s === false,
  array: (a: any): boolean => Array.isArray(a),
  object: (obj: any): boolean =>
    obj && !is.array(obj) && typeof obj === 'object',
  promise: (p: any): boolean => p && is.func(p.then),
  generator: (obj: any): boolean => is.func(obj.next) && is.func(obj.throw),
  generatorFunc: (obj: any): boolean => {
    const { constructor } = obj
    if (!constructor) return false
    if (
      constructor.name === 'GeneratorFunction' ||
      constructor.displayName === 'GeneratorFunction'
    )
      return true
    return is.generator(constructor.prototype)
  },
}

export default is
